// selectors.js
import { createSelector } from 'reselect';


const getEmp = (state) => state.EmployeeData.employee;
export const selectEmployees = createSelector(
  [getEmp],
  (emp) => emp || { data: [] }
);

const geticode = (state) => state.ItemData.icode;
export const selecticode = createSelector(
  [geticode],
  (icode) => icode || { data: [] }
);

const getItems = (state) => state.ItemData.item;
export const selectItems = createSelector(
  [getItems],
  (items) => items || { data: [] }
);

const getItemMaterial = (state) => state.ItemData.material;
export const selectItemMaterialData = createSelector(
  [getItemMaterial],
  (items) => items || { data: [] }
);

const getItemAvg = (state) => state.ItemAvgData.itemAvg;
export const selectItemAvg = createSelector(
  [getItemAvg],
  (itemAvg) => itemAvg || { data: [] }
);


const getCloths = (state) => state.ClothData.cloth;
export const selectCloths = createSelector(
  [getCloths],
  (cloths) => cloths || { data: [] }
);

const getPanna = (state) => state.PannaData.pana;
export const selectPanna = createSelector(
  [getPanna],
  (panna) => panna || { data: [] }
);

const getTrasnport = (state) => state.TransportData.transport;
export const selectTransports = createSelector(
  [getTrasnport],
  (transpt) => transpt || { data: [] }
);


const getPoNo = (state) => state.PoNoData.PoNo;
export const selectPoNo = createSelector(
  [getPoNo],
  (Pono) => Pono || { data: [] }
);

const getAllPoNos = (state) => state.PoNoData.allPONo;
export const selectAllPONumbers = createSelector(
  [getAllPoNos],
  (ponos) => ponos || { data: [] }
);

const getTempBaleLump = (state) => state.PoNoData.tempBale;
export const selectTempBaleLump = createSelector(
  [getTempBaleLump],
  (tempBale) => tempBale || { data: [] }
);

const getParts = (state) => state.PartyData.party;
export const selectParty = createSelector(
  [getParts],
  (party) => party || { data: [] }
);

const getFirms = (state) => state.FirmData.firm;
export const selectFirm = createSelector(
  [getFirms],
  (firm) => firm || { data: [] }
);


const getStates = (state) => state.StatesData.states;
export const selectState = createSelector(
  [getStates],
  (states) => states || { data: [] }
);

const getRack = (state) => state.RackData.rack;
export const selectRack = createSelector(
  [getRack],
  (racks) => racks || { data: [] }
);

const getJobrate = (state) => state.JobRateData.jobrate;
export const selectJobRate = createSelector(
  [getJobrate],
  (jobrate) => jobrate || { data: [] }
);

const getSingleJob = (state) => state.JobRateData.singleJobRate;
export const selectSingleJobrate = createSelector(
  [getSingleJob],
  (jobrate) => jobrate || { data: [] }
);

const getPricePerGrp = (state) => state.PricePerData.pricePer;
export const selectPriPerGrp = createSelector(
  [getPricePerGrp],
  (priceper) => priceper || { data: [] }
);

const getPodata = (state) => state.PoNoData.podata;
export const selectPOData = createSelector(
  [getPodata],
  (podata) => podata || { data: [] }
);

const getPINo = (state) => state.PurchaseInwardData.piNo;
export const selectPINos = createSelector(
  [getPINo],
  (Pino) => Pino || { data: [] }
);

const getPOExtra = (state) => state.PoNoData.poExtra;
export const selectPOExtra = createSelector(
  [getPOExtra],
  (poextra) => poextra || { data: [] }
);

const getPOAllExtra = (state) => state.PoNoData.allPOExtraNo;
export const selectAllPONoExtra = createSelector(
  [getPOAllExtra],
  (allPono) => allPono || { data: [] }
);

const getPIdata = (state) => state.PurchaseInwardData.purchaseinward;
export const selectPIData = createSelector(
  [getPIdata],
  (pidata) => pidata || { data: [] }
);

const getSchool = (state) => state.SchoolData.school;
export const selectSchool = createSelector(
  [getSchool],
  (schl) => schl || { data: [] }
);

const getQuotNo = (state) => state.QuotationData.quotNo;
export const selectQuotNo = createSelector(
  [getQuotNo],
  (quotNo) => quotNo || { data: [] }
);

const getQuotationNo = (state) => state.QuotationData.quotationNo;
export const selectQuotationNo = createSelector(
  [getQuotationNo],
  (quotNo) => quotNo || { data: [] }
);

const getQuotData = (state) => state.QuotationData.quotData;
export const selectQuotData = createSelector(
  [getQuotData],
  (quotData) => quotData || { data: [] }
);

const getLogo = (state) => state.LogoData.logo;
export const selectLogo = createSelector(
  [getLogo],
  (logo) => logo || { data: [] }
);

const getSOno = (state) => state.SaleOrderData.sono;
export const selectsono = createSelector(
  [getSOno],
  (sono) => sono || { data: [] }
);

const getsalebarcd = (state) => state.SaleOrderData.barcode;
export const selectSalebarcd = createSelector(
  [getsalebarcd],
  (barcd) => barcd || { data: [] }
);

const getSaleOrdData = (state) => state.SaleOrderData.saleorder;
export const selectSOData = createSelector(
  [getSaleOrdData],
  (sodata) => sodata || { data: [], info: [] }
);

const getsoQuot = (state) => state.SaleOrderData.soquot;
export const selectSOQuotData = createSelector(
  [getsoQuot],
  (soquot) => soquot || { data: [], quotnos: [] }
);

const getQuotView = (state) => state.QuotationData.Qviewlist;
export const selectQuotView = createSelector(
  [getQuotView],
  (view) => view || { data: [], avgs: [] }
);

const getQtEntryNo = (state) => state.SaleOrderData.qtEntry;
export const selectQTEntryNo = createSelector(
  [getQtEntryNo],
  (view) => view || { data: [] }
);

const getSOwiseParty = (state) => state.SaleOrderData.partylist;
export const selectSOwiseParty = createSelector(
  [getSOwiseParty],
  (party) => party || { data: [] }
);

const getSOReg = (state) => state.SaleOrderData.solist;
export const selectSOlistReg = createSelector(
  [getSOReg],
  (solist) => solist || { data: [] }
);

const getSOinfo = (state) => state.SaleOrderData.soinfo;
export const selectSOinfo = createSelector(
  [getSOinfo],
  (soinfo) => soinfo || { data: [], totQty: [] }
);

const getSOnoinfolist = (state) => state.SaleOrderData.sonolist;
export const selectSONOinfolist = createSelector(
  [getSOnoinfolist],
  (sonolist) => sonolist || { data: [], totQty: [], infoData: [] }
);

const getMemo = (state) => state.CuttingData.memo;
export const selectMemoNo = createSelector(
  [getMemo],
  (memo) => memo || { data: [] }
);

const getChallan = (state) => state.ClothIssueData.challanNo;
export const selectChallanNo = createSelector(
  [getChallan],
  (challan) => challan || { data: [] }
);

const getLumpbar = (state) => state.ClothIssueData.lumpbarcd;
export const selectLumpBarcode = createSelector(
  [getLumpbar],
  (lumpbarcd) => lumpbarcd || { data: [] }
);

const getBalelist = (state) => state.ClothIssueData.baleList;
export const selectBalelist = createSelector(
  [getBalelist],
  (bale) => bale || { data: [], SOdata: [], onlySOno: [], contractorSO: [] }
);

const getClothIssue = (state) => state.ClothIssueData.clothIssue;
export const selectClothIssue = createSelector(
  [getClothIssue],
  (clIssue) => clIssue || { data: [], manualemp: [], soemp: [], contractorEmp: [], contSOemp: [], SOdata: [] }
);

const getClothIssueInfo = (state) => state.ClothIssueData.clothIsInfo;
export const selectClothIsInfo = createSelector(
  [getClothIssueInfo],
  (clIssInfo) => clIssInfo || { data: [] }
);

const getMasterMlist = (state) => state.CuttingDatalist.masterMlist;
export const selectMasterMlist = createSelector(
  [getMasterMlist],
  (master) => master || { data: [], sono: [], contractor: [], contsono: [] }
);

const getCuttinglist = (state) => state.CuttingDatalist.cuttinglist;
export const selectCuttingDatalist = createSelector(
  [getCuttinglist],
  (cut) => cut || { data: [], data2: [], cuttingInfo: [], cuttingInfo2: [], cuttingCloths: [], countId: [], gMtr: [] }
);

const getContractorMemo = (state) => state.CuttingDatalist.contMemo;
export const selectContractorMemo = createSelector(
  [getContractorMemo],
  (contMemo) => contMemo || { data: [] }
);

const getContractorReturnMemo = (state) => state.CuttingDatalist.contRememo;
export const selectContractorRememo = createSelector(
  [getContractorReturnMemo],
  (contMemo) => contMemo || { data: [] }
);

const getCuttingReturnlist = (state) => state.CuttingDatalist.cutReturn;
export const selectCutReturnlist = createSelector(
  [getCuttingReturnlist],
  (cutReturn) => cutReturn || { data: [], mainInfo: [], returnInfo: [], cuttingInfo: [] }
);

const getContReturnlist = (state) => state.CuttingDatalist.contReturn;
export const selectContReturnlist = createSelector(
  [getContReturnlist],
  (contReturn) => contReturn || { data: [], returnInfo: [], cuttingInfo: [] }
);

const getContReGrplist2 = (state) => state.CuttingDatalist.cutReGrp;
export const selectContReGrplist2 = createSelector(
  [getContReGrplist2],
  (cutReGrp) => cutReGrp || { data: [], returnInfo: [], cuttingInfo: [] }
);

const getAllCutReturnInlist = (state) => state.CuttingDatalist.allInReturn;
export const selectAllCutReturnInlist = createSelector(
  [getAllCutReturnInlist],
  (allInReturn) => allInReturn || { data: [] }
);

const getAllCutReturnContlist = (state) => state.CuttingDatalist.allContReturn;
export const selectAllCutReturnContlist = createSelector(
  [getAllCutReturnContlist],
  (allcontReturn) => allcontReturn || { data: [] }
);

const getChanllanId = (state) => state.ClothIssueData.chanllanId;
export const selectChanllanId = createSelector(
  [getChanllanId],
  (challan) => challan || { data: [] }
);

const getBrand = (state) => state.RackData.brand;
export const selectBrandlist = createSelector(
  [getBrand],
  (brand) => brand || { data: [] }
);

const getSingleBrand = (state) => state.RackData.singlebrand;
export const selectSingleBrand = createSelector(
  [getSingleBrand],
  (brand) => brand || { data: [] }
);